// extracted by mini-css-extract-plugin
export default {"img":"MainPage_img__8ju9d","div_img":"MainPage_div_img__8iWxf","div_img_september":"MainPage_div_img_september__VtB0I"};